import React, {Component} from 'react';
import isMobile from 'ismobilejs';

import Registry from '../../../registry';

import './styles.scss';

import Button from '../UIKit/Button';
import Checkbox from '../UIKit/Checkbox';
import Select from '../UIKit/Select';
import PlusOneIcon from '../UIKit/Icon/PlusOne.js';

class ShowroomSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showroom_price: props.currentRoom.showroom_price,
            showroom_activated: props.currentRoom.showroom_price > 0
        }
        this.remoteData = {
            showroom_price: props.currentRoom.showroom_price,
            showroom_activated: props.currentRoom.showroom_price > 0
        }
        this.sendDataTimeout = false;
        this.showroomPriceInputRef = React.createRef();
        this.showroomActivatedInputRef = React.createRef();
    }

    sendData() {
        const siteInterface = Registry.get('siteInterface');
        let showroom_price = 0;
        if (this.state.showroom_activated) {
            showroom_price = this.state.showroom_price;
            if (!showroom_price) showroom_price = 1;
        }
        siteInterface.setRoomOptions({
            action: "update",
            roomid: this.props.currentRoom.id,
            showroom_price: showroom_price
        });
        if (this.props.onSuccess) this.props.onSuccess();
        this.remoteData = {
            showroom_price: showroom_price,
            showroom_activated: showroom_price > 0
        }
    };

    onChangePrice(newPrice) {
        this.setState({showroom_price: newPrice}, () => {
            this.maybeSendData();
        });
    }

    onActivateShowroom(activated) {
        if (!this.state.showroom_price) {
            this.setState({showroom_price: 1});
        }
        this.setState({showroom_activated: activated}, () => {
            this.maybeSendData();
        });
    }

    maybeSendData() {
        if (this.sendDataTimeout) {
            clearTimeout(this.sendDataTimeout);
            this.sendDataTimeout = false;
        }

        if (this.state.showroom_price != this.remoteData.showroom_price ||
            this.state.showroom_activated != this.remoteData.showroom_activated) {
            this.sendDataTimeout = setTimeout(this.sendData.bind(this), 5000);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.currentRoom.showroom_price != prevProps.currentRoom.showroom_price) {
            this.setState({
                showroom_price: this.props.currentRoom.showroom_price,
                showroom_activated: this.props.currentRoom.showroom_price != 0
            });
        }
        //console.log("ShowroomSettings update", prevState);
        //console.log("ShowroomSettings update", snapshot);
    }

    render() {
        const lang = Registry.get('locale');
        let chatInterface = Registry.get('chatInterface');
        if (!chatInterface.can("my_show")) return null;

        const {currentUser, currentRoom} = this.props;
        const isAnonymous = currentUser.isAnonymous();
        const isUserFree = !currentUser.isAnonymous() && !currentUser.isXXL();

        const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

        return (
            <div className='ShowroomSettings'>

                <div className='settings-tab'>
                    <div className="options">
 
                        <Checkbox text={lang.activate_showroom}
                            checked={this.state.showroom_activated}
                            onChange={this.onActivateShowroom.bind(this)}
                            ref={this.showroomActivatedInputRef}/>
                        {this.state.showroom_activated &&
                            <Select ref={this.showroomPriceInputRef}
                                ux="buttons" label=""
                                value={this.state.showroom_price}
                                onChange={this.onChangePrice.bind(this)}
                                options={[
                                    {"button" : <PlusOneIcon size="large" label="+1" />, "key":1, "value": 1},
                                    {"button" : <PlusOneIcon size="large" label="+2" />, "key":2, "value": 2},
                                    {"button" : <PlusOneIcon size="large" label="+3" />, "key":3, "value": 3},
                                    {"button" : <PlusOneIcon size="large" label="+4" />, "key":4, "value": 4},
                                    {"button" : <PlusOneIcon size="large" label="+5" />, "key":5, "value": 5}]}/>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default ShowroomSettings;



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/ShowroomSettings/index.js